'use client';

import { Button } from '@common/components';

import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { useGlobalStore } from '@/stores/GlobalStore';

/**
 * ⑩ 회원가입 CTA + 공유 + 면책 + 출처.
 * - 메인 CTA: 비로그인 → 로그인 페이지, 로그인 → 맞춤정책 페이지.
 * - 공유: 전역 ShareDrawer (Kakao SDK / Web Share / 클립보드 폴백 통합).
 */
export const FinalCta = () => {
  const router = useCustomRouter();
  const isLogin = useAuthStore((state) => state.isLogin);
  const setShareLink = useGlobalStore((state) => state.setShareLink);

  const handleCtaClick = () => {
    if (isLogin === undefined) return;
    if (!isLogin) {
      router.push(
        ROUTES.LOGIN.withSearchParams({
          searchParams: { redirect: ROUTES.RECOMMEND_POLICY_LIST.pathname },
        }),
      );

      return;
    }
    router.push(ROUTES.RECOMMEND_POLICY_LIST.pathname);
  };

  const handleShare = () => {
    if (typeof window === 'undefined') return;
    setShareLink(window.location.href);
  };

  return (
    <section className="flex flex-col gap-16 mobile-tablet:px-16">
      <div className="flex flex-col items-center gap-16 py-24">
        <Image
          src="https://www.welfarehello.com/assets/pngs/silver-coin.png"
          alt="로고 실버 코인 이미지"
          className="size-120"
          width={120}
          height={120}
        />
        <div className="flex flex-col items-center gap-2 text-center">
          <p className="text-Gray-500 typo-body4">회원가입하고</p>
          <p className="text-Gray-900 typo-body3">
            <strong className="font-700">내게 딱 맞는 정책</strong> 확인하기
          </p>
        </div>

        <div className="flex w-full flex-col gap-12">
          <Button
            theme="primary-fill"
            dimensions="H48"
            className="w-full"
            onClick={handleCtaClick}
          >
            내 맞춤정책 확인하기 →
          </Button>
          <Button
            theme="sub-line"
            dimensions="H48"
            className="w-full"
            onClick={handleShare}
          >
            공유하기
          </Button>
        </div>
      </div>
    </section>
  );
};
